import { LETTERBOX_TOF_VIEWED } from './types';

export const triggerSlideIsViewed = (position, total, placement) => ({
  type: LETTERBOX_TOF_VIEWED,
  position,
  total,
  placement,
});
